var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1799 135.15H3.67993L14.9999 80.09C15.2302 78.7907 15.9026 77.6111 16.9031 76.7509C17.9037 75.8906 19.1708 75.4028 20.4899 75.37H102.88C103.578 75.4005 104.26 75.5853 104.878 75.9109C105.496 76.2365 106.034 76.695 106.454 77.2533C106.874 77.8117 107.165 78.4561 107.306 79.1402C107.447 79.8243 107.435 80.5311 107.27 81.21L96.1799 135.15Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.98 75.23L96.9199 63.08L113.97 53.72L116.36 63.56L120.49 61.52L122.98 75.23Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.87 56.81C131.597 57.3968 131.157 57.8896 130.604 58.2258C130.051 58.5621 129.411 58.7267 128.764 58.699C128.118 58.6712 127.494 58.4522 126.972 58.0698C126.45 57.6874 126.053 57.1587 125.832 56.5506C125.61 55.9426 125.574 55.2825 125.728 54.654C125.882 54.0255 126.219 53.4568 126.697 53.0199C127.174 52.583 127.77 52.2975 128.41 52.1996C129.05 52.1017 129.704 52.1958 130.29 52.47C131.072 52.8389 131.677 53.5019 131.973 54.3148C132.269 55.1276 132.232 56.0244 131.87 56.81Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.53 30.95H81.7V18.11L94.53 30.95Z",
    fill: "#DB6C2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.53 30.95H81.7V18.11L94.53 30.95Z",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0898 70.68L102.44 24.89L148.68 46.45L127.12 92.68L111.87 85.57",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5698 71.0699V22.7499C38.5685 22.2816 38.6596 21.8176 38.838 21.3845C39.0163 20.9514 39.2783 20.5578 39.609 20.2262C39.9397 19.8945 40.3326 19.6314 40.7652 19.4519C41.1977 19.2723 41.6615 19.1799 42.1298 19.1799H82.0598",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.26 42.6699H81.23",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.26 51.11H77.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.26 59.5499H81.23",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.26 67.98H69.67",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67993 135.15V54.38H27.8599L31.9199 62.25H37.1699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPhoto);
export default __webpack_public_path__ + "static/media/folder_photo.9c8388c77909a4807ebbecd6a2e38aa1.svg";
export { ForwardRef as ReactComponent };